export default "__VITE_ASSET__D2rTh0wh__"